import { render, staticRenderFns } from "./WeekPicker.vue?vue&type=template&id=1647e035&scoped=true&"
import script from "./WeekPicker.vue?vue&type=script&lang=js&"
export * from "./WeekPicker.vue?vue&type=script&lang=js&"
import style0 from "./WeekPicker.vue?vue&type=style&index=0&id=1647e035&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1647e035",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCalendar } from 'vuetify/lib/components/VCalendar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCalendar,VIcon,VSheet})
